import React from "react";

import { faSearch, faSpinnerThird, faTimes } from "@awesome.me/kit-4c83d50d0d/icons/classic/light";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import styles from "./css/SearchBox.module.css";

export function SearchBox({
	value,
	onChange,
	onClear,
	onKeyDown,
	className,
	loading = false,
}: {
	value: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onClear: () => void;
	onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
	className?: string;
	loading?: boolean;
}) {
	return (
		<label className={cx(styles.searchBoxContainer, className)}>
			{loading ? (
				<FontAwesomeIcon fixedWidth icon={faSpinnerThird} className={styles.searchIcon} spin />
			) : (
				<FontAwesomeIcon fixedWidth icon={faSearch} className={styles.searchIcon} />
			)}
			<input
				type="search"
				placeholder="Search templates"
				value={value}
				onChange={onChange}
				onKeyDown={onKeyDown}
				className={styles.searchBox}
			/>
			{value && (
				<button title="Clear search" className={styles.searchClearButton} onClick={onClear}>
					<FontAwesomeIcon fixedWidth icon={faTimes} />
				</button>
			)}
		</label>
	);
}
